<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout justify-center>
          <v-flex xs12 sm8 md6>
            <v-card class="elevation-12">
              <v-toolbar dark color="primary">
                <v-toolbar-title>ログイン</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form ref="form" lazy-validation>
                  <v-text-field
                    v-model="email"
                    required
                    :rules="emailRules"
                    prepend-icon="mdi-email"
                    name="login"
                    label="メール"
                    type="text"
                  ></v-text-field>
                  <v-text-field
                    v-model="password"
                    required
                    id="password"
                    prepend-icon="mdi-lock"
                    name="password"
                    label="パスワード"
                    type="password"
                  ></v-text-field>
                </v-form>
                <div v-show="feedback" class="red--text text-center">
                  {{ feedback }}
                </div>
              </v-card-text>
              <v-card-actions>
                <v-btn text small color="primary" @click="passwordReset"
                  >パスワードリセット</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="login">ログイン</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import firebase from "firebase";
import { database as db } from "./utils-firebase.js";
export default {
  name: "Login",
  data: () => ({
    password: null,
    email: "",
    emailRules: [
      v => !!v || "E-mailは必須です",
      v => /.+@.+/.test(v) || "正しいE-mailを入力してください"
    ],
    feedback: null
  }),

  methods: {
    login() {
      this.feedback = "処理中";
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(cred => {
          console.log(cred)
          return db
            .collection("users")
            .doc(cred.user.uid)
            .get();
        })
        .then(doc => {
          console.log(doc.data())
          if (doc.data().role == "admin") {
            this.$router.push({ name: "TeacherView" });
          } else {
            this.$router.push({ name: "StudentView" });
          }
        })
        .catch(err => {
          console.log(err)
          if (err.code == "auth/user-not-found") {
            this.feedback =
              "ユーザが登録されていません。管理者に登録を依頼してください。";
          } else if (err.code == "auth/wrong-password") {
            this.feedback = "パスワードが正しくありません。";
          } else {
            this.feedback = err.message;
          }
        });
    },
    sendEmail() {
      var user = firebase.auth().currentUser;
      let self = this;
      if (user) {
        user
          .sendEmailVerification()
          .then(function() {
            self.feedback =
              "受信メールのリンクをクリック後、ログインしてください";
          })
          .catch(function(err) {
            self.feedback = err.message;
          });
      } else {
        self.feedback = "ログインした後で送信してください";
      }
    },
    passwordReset() {
      let self = this;
      firebase
        .auth()
        .sendPasswordResetEmail(this.email)
        .then(function() {
          self.feedback = "メールを送信しました。";
        })
        .catch(function(err) {
          self.feedback = err.message;
        });
    }
  }
};
</script>
